import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import { Menu, X } from "react-feather"
import BrandLogo from "./brand-logo.js"
import BrandSmallLogo from "./brand-small-logo.js"
import * as styles from "./header.css"
import NavItemGroup from "./nav-item-group"
import {
  Base,
  Button, Container,
  Flex,
  FlexList, InteractiveIcon, NavLink, Nudge, Space, VisuallyHidden
} from "./ui"

const Header = () => {
  const [header, setHeader] = React.useState(false);

  const listenScrollEvent = event => {
    if (window.scrollY < 78) {
      return setHeader(false);
    } else {
      return setHeader(true);
    }
  };

  React.useEffect(() => {
    listenScrollEvent(null);

    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);

  const {
    desktopHeaderNavWrapper, desktopHeaderNavTranspWrapper, mobileHeaderNavWrapper, mobileNavLink,
    mobileNavOverlay, mobileNavSVGColorWrapper, tabletHeaderNavWrapper
  } = styles;
  const data = useStaticQuery(graphql`
    query {
      layout {
        header {
          id
          navItems {
            id
            navItemType
            ... on NavItem {
              href
              text
            }
            ... on NavItemGroup {
              name
              navItems {
                id
                href
                text
                description
                icon {
                  alt
                  gatsbyImageData
                }
              }
            }
          }
          cta {
            id
            href
            text
          }
        }
      }
    }
  `)

  const { navItems, cta } = data.layout.header
  const [isOpen, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "visible"
    }
  }, [isOpen])

  return (
    <Base as="header" style={{ width: '100%', zIndex: 100, position: 'absolute' }}>
      <Base className={header ? desktopHeaderNavWrapper : desktopHeaderNavTranspWrapper}>
        <Container>
          <Flex variant="spaceBetween">
            <NavLink to="/" style={{ paddingTop: 5, paddingBottom: 5 }}>
              <VisuallyHidden>Home</VisuallyHidden>
              <BrandLogo color={header ? '#0092D9' : "#ffffff"} />
            </NavLink>
            <div style={{ flexDirection: 'row', display: 'flex' }}>
              <nav style={{ marginRight: 48, paddingTop: 11, paddingBottom: 11 }}>
                <FlexList gap={4}>
                  {navItems &&
                    navItems.map((navItem) => (
                      <li key={navItem.id}>
                        {navItem.navItemType === "Group" ? (
                          <NavItemGroup
                            name={navItem.name}
                            navItems={navItem.navItems}
                          />
                        ) : (
                          <NavLink to={navItem.href} target="_blank">{navItem.text}</NavLink>
                        )}
                      </li>
                    ))}
                </FlexList>
              </nav>
              {cta && <Button to={'#heroForm'}>{cta.text}</Button>}
            </div>
          </Flex>
        </Container>
      </Base>
      <Container className={mobileHeaderNavWrapper[isOpen ? "open" : "closed"]}>
        <Flex variant="spaceBetween">
          <span
            className={
              mobileNavSVGColorWrapper[isOpen ? "reversed" : "background"]
            }
          >
            <NavLink to="/">
              <VisuallyHidden>Home</VisuallyHidden>
              {
                isOpen ?
                  <BrandLogo color={"#0092D9"} /> :
                  <div style={{ paddingTop: 10 }}> <BrandSmallLogo color={"#0092D9"} /> </div>
              }
            </NavLink>
          </span>
          <Flex>
            <Nudge right={3}>
              <InteractiveIcon
                title="Toggle menu"
                onClick={() => setOpen(!isOpen)}
                className={
                  mobileNavSVGColorWrapper[isOpen ? "reversed" : "terciary"]
                }
              >
                {isOpen ? <X /> : <Menu />}
              </InteractiveIcon>
            </Nudge>
          </Flex>
        </Flex>
      </Container>
      <Container className={tabletHeaderNavWrapper[isOpen ? "open" : "closed"]}>
        <Flex variant="spaceBetween">
          <span
            className={
              mobileNavSVGColorWrapper[isOpen ? "reversed" : "primary"]
            }
          >
            <NavLink to="/">
              <BrandLogo color={"#0092D9"} />
            </NavLink>
          </span>
          <Flex>
            <Space />
            <Nudge right={3}>
              <InteractiveIcon
                title="Toggle menu"
                onClick={() => setOpen(!isOpen)}
                className={
                  mobileNavSVGColorWrapper[isOpen ? "reversed" : "primary"]
                }
              >
                {isOpen ? <X /> : <Menu />}
              </InteractiveIcon>
            </Nudge>
          </Flex>
        </Flex>
      </Container>
      {isOpen && (
        <div className={mobileNavOverlay}>
          <nav>
            <FlexList style={{ flexDirection: 'column', alignItems: 'flex-start' }} gap={0}>
              {navItems?.map((navItem, index) => (
                <li key={navItem.id} style={{ borderLeft: (index === 0 ? '8px solid #0092D9' : '8px solid #D9D9D9'), lineHeight: '24px', marginBottom: 24 }}>
                  <NavLink to={navItem.href} className={mobileNavLink} style={{ color: (index === 0) ? '#0092D9' : '#383838' }}>
                    {navItem.text}
                  </NavLink>
                </li>
              ))}
              <li style={{ padding: 16 }}>
                {cta && <Button to={'#heroForm'}>{cta.text}</Button>}
              </li>
            </FlexList>
          </nav>
        </div>
      )}
    </Base>
  )
}

export default Header;